__turbopack_context__.v({
  "primary-body-bold": "Typography-module__z8_Gmq__primary-body-bold",
  "primary-body-regular": "Typography-module__z8_Gmq__primary-body-regular",
  "primary-l-extra-bold": "Typography-module__z8_Gmq__primary-l-extra-bold",
  "primary-m-extra-bold": "Typography-module__z8_Gmq__primary-m-extra-bold",
  "primary-s-extra-bold": "Typography-module__z8_Gmq__primary-s-extra-bold",
  "primary-s-regular": "Typography-module__z8_Gmq__primary-s-regular",
  "primary-xl-extra-bold": "Typography-module__z8_Gmq__primary-xl-extra-bold",
  "primary-xs-bold": "Typography-module__z8_Gmq__primary-xs-bold",
  "primary-xs-regular": "Typography-module__z8_Gmq__primary-xs-regular",
  "primary-xxs-bold": "Typography-module__z8_Gmq__primary-xxs-bold",
  "primary-xxs-regular": "Typography-module__z8_Gmq__primary-xxs-regular",
  "secondary-l-bold": "Typography-module__z8_Gmq__secondary-l-bold",
  "secondary-m-bold": "Typography-module__z8_Gmq__secondary-m-bold",
  "secondary-s-bold": "Typography-module__z8_Gmq__secondary-s-bold",
  "secondary-s-regular": "Typography-module__z8_Gmq__secondary-s-regular",
  "secondary-xl-bold": "Typography-module__z8_Gmq__secondary-xl-bold",
  "secondary-xs-bold": "Typography-module__z8_Gmq__secondary-xs-bold",
  "secondary-xs-regular": "Typography-module__z8_Gmq__secondary-xs-regular",
  "secondary-xxl-bold": "Typography-module__z8_Gmq__secondary-xxl-bold",
  "secondary-xxs-bold": "Typography-module__z8_Gmq__secondary-xxs-bold",
  "secondary-xxs-regular": "Typography-module__z8_Gmq__secondary-xxs-regular",
});
